export enum MessageStatus {
  updateInProgress = 'em-analise',
  unlockedForEdit = 'em-analise',
  updateCompleted = 'alterado',
  updateFailed = 'nao-realizada',
}
